import type {AgentName} from 'services/agent/types';

export const splitPersonName = (fullName: string): AgentName => {
  const trimmedName = fullName.trim();
  const match =
    /^(?<surName>[^,]+),\s*(?<name>.+)$/.exec(trimmedName) ??
    /^(?<name>.+)\s(?<surName>\S+)$/.exec(trimmedName);

  return match?.groups
    ? {surName: match.groups.surName.trim(), name: match.groups.name.trim()}
    : {name: trimmedName};
};
